import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './index.scss';

export default function Input(props) {
  const {
    className,
    style,
    label,
    helperText,
    leftText,
    disableLeft,
    onLeftClick,
    value,
    placeholder,
    type,
    autoComplete,
    autoCorrect,
    autoCapitalize,
    onChange,
    onBlur,
    focus,
    disabled,
    required,
  } = props;

  const [focused, setFocused] = useState(false);

  // Render button
  return (
    <div
      style={style}
      className={clsx(className, 'input-container', styles.container, disabled && 'disabled')}
    >
      {!helperText && label && <div className={clsx('input-label', styles.label)}>{label}</div>}
      {helperText && (
        <div className={clsx('input-helper-text', styles.helperText)}>{helperText}</div>
      )}
      <div
        className={clsx(
          'input-box',
          focused && 'input-box-focused',
          styles.inputBox,
          focused && styles.focused
        )}
      >
        {leftText && (
          <div
            className={clsx(
              'input-left-text',
              disableLeft && 'input-left-text-disabled',
              styles.leftText,
              disableLeft && styles.leftDisabled
            )}
            onClick={() => !disabled && !disableLeft && onLeftClick?.()}
          >
            {leftText}
          </div>
        )}
        <input
          className={clsx('input-field', styles.input)}
          value={value}
          placeholder={placeholder}
          type={type}
          onChange={(event) => !disabled && onChange?.(event?.target?.value)}
          onFocus={() => setFocused(true)}
          onBlur={(event) => {
            onBlur?.(event?.target?.value);
            setFocused(false);
          }}
          autoCorrect={autoCorrect}
          autoCapitalize={autoCapitalize}
          autoComplete={autoComplete}
          autoFocus={focus}
          disabled={disabled}
          required={required}
        />
      </div>
    </div>
  );
}
